import * as numeral from 'numeral';
import 'numeral/locales/pt-br';

export const barChartOptions: any = {
  legend: {
    display: true,
  },
  scaleShowVerticalLines: false,
  elements: {
    line: {
      fill: false,
      tension: 0, // disables bezier curves
      borderDash: [],
      borderCapStyle: 'butt',
      borderDashOffset: 0.0,
      borderJoinStyle: 'miter'
    },
    point: {
      backgroundColor: '#FFFFFF',
      borderWidth: 1,
      hoverRadius: 5,
      hoverBorderWidth: 2,
      radius: 5,
      hitRadius: 10
    }
  },
  scales: {
    xAxes: [{
      gridLines: {
        display: false
      },
      stacked: false
    }],
    yAxes: [{
      gridLines: {
        display: true
      },
      stacked: false,
      ticks: {
        beginAtZero: true,
        // Include a dollar sign in the ticks
        callback: (value, index, values) => {
          return numeral(value).format('0,0');
        }
      }
    }]
  },
  tooltips: {
    callbacks: {
      label: (tooltipItem, data) => {
        const allData = data.datasets[tooltipItem.datasetIndex].data;
        const tooltipLabel = data.labels[tooltipItem.index];
        const tooltipData = allData[tooltipItem.index];
        const dataLabel = data.datasets[tooltipItem.datasetIndex].label;

        return `${ dataLabel }: ${ numeral(tooltipData).format('0,0') }`;
      }
    }
  },
  plugins: {
    datalabels: {
      display: true,
      backgroundColor: 'white',
      // backgroundColor: function(context) {
      //   return context.dataset.backgroundColor;
      // },
      borderRadius: 5,
      color: '#333',
      font: {
        weight: 'bold'
      },
      align: 'center',
      anchor: 'center',
      padding: 5,
      opacity: .7,
      formatter: function (value, context) {
        return numeral(value).format('0,0');
      }
    }
  }
};
